module.exports = __webpack_public_path__ + "img/Property 1=4x3, Property 2=GE - Georgia.5d8df211.svg";